import { defineStore } from "pinia";
import { User } from "@/types";
import type { ISession } from "@/types";
import { fetchWrapper } from "@/helpers/fetch-wrapper";

export const useSessionStore = defineStore({
  id: "session",
  persist: {
    paths: ["session"],
  },
  state: () => ({
    session: {} as ISession,
  }),
  getters: {
    isAuthenticated: (state) => state.session.isAuthenticated ?? false,
    isSuperAdmin: (state) => state.session.isSuperAdmin ?? false,
    role: (state) => state.session.role,
    canChangePassword: (state) => state.session.canChangePassword ?? false,
    canPublishProducts: (state) => state.session.currentOrg?.canPublishProducts ?? false,
    canPartnerWithOrgs: (state) => state.session.currentOrg?.canPartnerWithOrgs ?? false,
  },
  actions: {
    setSession(data: any) {
      this.session = {
        ...this.session,
        isAuthenticated: true,
        user: new User(data.user),
        currentOrgId: data.currentOrgId,
        currentOrgName: data.currentOrgName,
        isSuperAdmin: data.isSuperAdmin,
        role: data.role,
        connectionCallbackUrl: data.connectionCallbackUrl,
        canChangePassword: data.canChangePassword,
        currentOrg: {
          orgId: data.currentOrgId,
          orgName: data.currentOrgName,
          canPublishProducts: data.canPublishProducts,
          canPartnerWithOrgs: data.canPartnerWithOrgs,
        },
      };
    },
    clearSession() {
      this.session = { isAuthenticated: false } as ISession;
    },
    async syncSession(): Promise<boolean> {
      try {
        const data = await fetchWrapper.get(
          `${import.meta.env.VITE_API_URL}/auth/session`,
          undefined,
          { skipAuthRedirect: true }
        );
        this.setSession(data);
        return true;
      } catch {
        this.clearSession();
        return false;
      }
    },
  },
});
